(function () {
  const initProductAccordion = () => {
    $('.about__accordion-toggle').each(function () {
      const currentToggle = $(this);

      // Guard: shopify:section:load re-runs this initialiser. Without it a
      // second click handler stacks up and open+close cancel each other out,
      // so the accordion looks like a no-op (theme editor / section reload).
      if (currentToggle.hasClass('content_started')) {
        return '';
      }
      currentToggle.addClass('content_started');

      const siblingToggles = currentToggle.siblings('.about__accordion-description');

      currentToggle.on('click', function () {
        if (!currentToggle.hasClass('active')) {
          $('.about__accordion-toggle').each(function () {
            const siblingToggle = $(this);
            siblingToggle.removeClass('active');
            siblingToggle.attr('aria-expanded', 'false');
            siblingToggle.siblings('.about__accordion-description').stop().slideUp(300);
          });

          currentToggle.addClass('active');
          currentToggle.attr('aria-expanded', 'true');

          siblingToggles.stop().slideDown(300, function () {
            const description = siblingToggles.get(0);
            if (!description) return;
            const rect = description.getBoundingClientRect();
            if (rect.top < 0 || rect.bottom > window.innerHeight) {
              description.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          });
        } else {
          currentToggle.removeClass('active');
          currentToggle.attr('aria-expanded', 'false');
          siblingToggles.stop().slideUp(300);
        }
      });
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper?.querySelectorAll('.js-image-zoom') || [];

    images.forEach((el) => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    });
  };

  const formatFreeShippingAmount = (value) => {
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = theme.moneyFormat;

    return formatString.replace(placeholderRegex, value);
  };

  const setTotalFreeShipping = () => {
    if (document.querySelector('.js-free-shipping')) {
      const freeShippingTotal = document.querySelector('.free-shipping-total');
      if (freeShippingTotal) {
        const minSpend = Number(freeShippingTotal.dataset.minSpend);
        if (minSpend && minSpend > 0) {
          freeShippingTotal.innerText = `${formatFreeShippingAmount(
            Math.round(minSpend * (Shopify.currency.rate || 1)),
          )}`;
        }
      }
    }
  };

  const revealStickyAddToCart = (section) => {
    if (!section && section.classList.contains('.product-section')) return;
    const buyButtons = section.querySelector('.product__buy-buttons > product-form');
    const stickyBar = section.querySelector('.sticky-add-to-cart');
    const footerBottom = document.querySelector(
      '.shopify-section-group-footer-group .footer__content-bottom',
    );

    if (!stickyBar) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.01,
    };

    const isElementBelowScroll = (element) => {
      return element ? element.getBoundingClientRect().top > 0 : false;
    };

    const toggleStickyBar = (isVisible) => {
      if (isVisible || isElementBelowScroll(buyButtons)) {
        stickyBar.classList.remove('active');
      } else {
        stickyBar.classList.add('active');
      }
    };

    const handleIntersect = (entries) => {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      toggleStickyBar(isVisible);
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);

    if (buyButtons) observer.observe(buyButtons);
    if (footerBottom) observer.observe(footerBottom);
  };

  document.addEventListener('shopify:section:load', function (event) {
    initProductAccordion();
    initZoomImage();
    setTotalFreeShipping();
    revealStickyAddToCart(event.target);
  });

  initProductAccordion();
  initZoomImage();
  setTotalFreeShipping();
  revealStickyAddToCart(document.currentScript.parentElement);
})();
